import {lensProp, map, over} from 'ramda'

import {defaultCountry} from '@daedalus/core/src/localization/business/countries'
import {Offer, OfferPrice} from '@daedalus/core/src/offer/types/offer'
import {Room} from '@daedalus/core/src/room/types/room'

import {RoomsStateType} from './slice'
import {updateAllPrices} from './updateAllPrices'

export const formatPrices = (rooms: Room[], state: RoomsStateType) =>
  deepUpdateRoomsPrices(rooms, price =>
    updateAllPrices(price, state.taxDisplayLogic || defaultCountry)
  )

export const deepUpdateRoomsPrices = (
  rooms: Room[],
  updateFn: (price: OfferPrice) => OfferPrice
) => {
  const offers = lensProp<Room, 'offers'>('offers')
  const prices = lensProp<Offer, 'prices'>('prices')
  return map(over(offers, map(over(prices, map(updateFn)))), rooms)
}
